import React from 'react';
import './landing/landing.css';
import { useLenis } from './landing/useLenis';
import { LandingNavbar } from './landing/LandingNavbar';
import { LandingHero } from './landing/LandingHero';
import { ProblemAgitation } from './landing/ProblemAgitation';
import { SolutionBenefit } from './landing/SolutionBenefit';
import { HonestProof } from './landing/HonestProof';
import { FAQAccordion } from './landing/FAQAccordion';
import { DemoForm } from './landing/DemoForm';
import { LandingFooter } from './landing/LandingFooter';

export default function LandingPage() {
  useLenis();

  return (
    <div data-testid="landing-page" className="sera-landing">
      <LandingNavbar />
      <LandingHero />
      <ProblemAgitation />
      <SolutionBenefit />
      <HonestProof />
      <FAQAccordion />
      <DemoForm />
      <LandingFooter />
    </div>
  );
}
